/**
 * Reusable page header with title/subtitle and slot for action buttons.
 * Stacks vertically on mobile so actions don't crowd the title.
 */
export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div
      className="sticky top-0 md:top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-[#E2E4E0] px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4"
      data-testid={testid}
    >
      <div className="db-h min-w-0">
        <h1 className="text-lg sm:text-2xl font-bold tracking-tight text-[#1A1D1A] truncate">{title}</h1>
        {subtitle && <p className="text-xs sm:text-sm text-[#5C665A] line-clamp-2">{subtitle}</p>}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">{actions}</div>
      )}
    </div>
  );
}
